import React from "react";
import styles from "./AudioBlock.module.scss";

export interface AudioBlockProps {
    audioFileUrl?: string;
    audioFileType?: string;
    description?: string;
}

const AudioBlock: React.FC<AudioBlockProps> = ({ audioFileUrl, audioFileType, description }) => {
    if (!audioFileUrl) {
        return null; // Don't render if no audio file is provided
    }
    return (
      <div className={styles.audioBlock}>
        <audio controls preload="metadata">
            <source src={audioFileUrl} type={audioFileType} />
            Your browser does not support the audio element.
        </audio>
        {description && <p className={styles.audioDescription}>{description}</p>}
      </div>
    );
  };
  
  export default AudioBlock;